import store from '../store/';
import { Route } from 'vue-router';
import {ProductGroupTypes} from '@/enums/ProductGroupTypes';

export default (to: Route, from: Route, next: any) => {
    // @ts-ignore
    const token = window.$cookies.isKey('token') ? window.$cookies.get('token') : null;
    if (!token && forbiddenRouteNamesLoggedIn.includes(to.name as string)) {
        next();
        return;
    }
    if (!token) {
        if(to.path === '/') {
            next('/login');
            return;
        } else {
            next({
                path: '/login',
                query: {
                nextUrl: to.path,
                },
            });
            return;
        }
    }
    if (to.name === 'StatisticalAnalysis' && !store.getters['user/currentStatisticalAnalysis']) {
        next(false);
    }
    if (to.name === 'SingleFolder' && !store.getters['projects/activeProject']) {
        next('/my-projects');
    }
    if (to.name === 'SingleRecordDetails' && !store.getters['projects/activeSingleReport']) {
        next('/my-projects');
    }
    const switchedUser = to.query._switch_user as string;
    store.dispatch('user/getUserData', token).then(() => {
        store.dispatch('user/refreshToken');
        if (to.name) {
            const activeGroup = store.getters['user/activeProductGroup'];
            if (activeGroup === ProductGroupTypes.None) {
                checkRedirectToWelcome(to.name, next, switchedUser, to.params);
            }
            checkPageAuthLoggedIn(to.name, next);
        }
        next();
    }).catch((e) => {
        console.error(e);
        store.dispatch('user/logoutUser');
        next('/login');
    });
};

const forbiddenRouteNamesLoggedIn =
    ['Login', 'Register', 'LoginFailed', 'EmailVerification', 'ResetPassword', 'ForgotPassword'];

function checkPageAuthLoggedIn(baseUrlName: string, redirect: (route: string) => void) {
    if (forbiddenRouteNamesLoggedIn.includes(baseUrlName)) {
        return redirect('/');
    }
}

const forbiddenRouteNamesWithoutCategorySelected = [
    'Search', 'SearchResults', 'ShoppingList', 'ShoppingCart', 'Payment'];

function checkRedirectToWelcome(
        baseUrlName: string,
        redirect: (route: string) => void,
        switchedUser: string,
        params?: any) {
    const includesTargetRoute = forbiddenRouteNamesWithoutCategorySelected.includes(baseUrlName);
    const isPaymentOptions = baseUrlName === 'Payment' && (params && params.type);
    if (includesTargetRoute && !isPaymentOptions) {
        const targetRoute = switchedUser ? `/welcome?_switch_user=${switchedUser}` : '/welcome';
        return redirect(targetRoute);
    }
}
